import React from 'react';

function SmoothConnector(props: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element {
    return (
        <div {...props}>
            <svg
                id="e7PJLGguTlb1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 73 49"
                shapeRendering="geometricPrecision"
                textRendering="geometricPrecision"
            >
                <path
                    d="M1,23h15.0882c2.4422,0,4.8753.2982,7.2453.888L72,36"
                    fill="none"
                    stroke="#cadbe8"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}

export default SmoothConnector;
